import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'

export default function PropertiesControllerProductSn(props) {
    const [{dpContentType = 'MM'}] = useProperties()

    const value = {
        MD: 'Markdown',
        MM: '思维导图',
    }[dpContentType]

    return (
        <Text
            label="模件格式"
            readOnly
            value={value}
            {...props}
        />
    )
}
